import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { ApiResponse, AppManagerModel, AppJoinedModel } from '../interface/app-config-model';

// Declare Meteor as a global to avoid TypeScript errors
declare const Meteor: any;


@Injectable({
    providedIn: 'root'
})
export class AppManagerService {
    private loadingSubject = new BehaviorSubject<boolean>(false);
    public loading$ = this.loadingSubject.asObservable();

    constructor() { }

    /**
     * Get all available apps from backend
     */
    getAllApps(): Observable<AppManagerModel[]> {
        const appsSubject = new BehaviorSubject<AppManagerModel[]>([]);

        Meteor.call('getAllAppManager', (error: any, result: ApiResponse) => {
            if (error) {
                appsSubject.error(error);
            } else {
                appsSubject.next(result.data as AppManagerModel[]);
            }
            appsSubject.complete();
        });

        return appsSubject.asObservable();
    }

    /**
     * Get installed apps for a specific user
     */
    getInstalledApps(userId: string): Observable<AppJoinedModel[]> {
        const installedAppsSubject = new BehaviorSubject<AppJoinedModel[]>([]);

        Meteor.call('getInstalledApp', userId, (error: any, result: ApiResponse) => {
            if (error) {
                installedAppsSubject.error(error);
            } else {
                installedAppsSubject.next(result.data as AppJoinedModel[]);
            }
            installedAppsSubject.complete();
        });

        return installedAppsSubject.asObservable();
    }

    /**
     * Install an app for a user
     */
    installApp(appManagerId: string, userId: string, desktopView: string): Observable<ApiResponse> {
        const installSubject = new BehaviorSubject<ApiResponse>({
            code: 0,
            message: '',
            error: null,
            data: []
        });
        this.loadingSubject.next(true);

        Meteor.call('installApp', appManagerId, userId, desktopView, (error: any, result: ApiResponse) => {
            this.loadingSubject.next(false);
            
            if (error) {
                installSubject.error(error);
            } else {
                installSubject.next(result);
            }
            installSubject.complete();
        });

        return installSubject.asObservable();
    }

    /**
     * Uninstall an app for a user
     */
    uninstallApp(appManagerId: string, userId: string): Observable<ApiResponse> {
        const uninstallSubject = new BehaviorSubject<ApiResponse>({
            code: 0,
            message: '',
            error: null,
            data: null
        });
        this.loadingSubject.next(true);

        Meteor.call('uninstallApp', appManagerId, userId, (error: any, result: ApiResponse) => {
            this.loadingSubject.next(false);
            
            if (error) {
                uninstallSubject.error(error);
            } else {
                uninstallSubject.next(result);
            }
            uninstallSubject.complete();
        });

        return uninstallSubject.asObservable();
    }
}

